import { Helmet } from "react-helmet";
import BreadCrumb from "../component/BreadCrumb";
import NativeLazyImage from "../component/NativeLazyImage";
import "./styles/AboutUsPage.style.css";
import HorizontalIconBox from "../component/HorizontalIconBox";

export default function ContactUsPage() {
  return (
    <main>
      <Helmet>
        <title>Contact Us | {process.env.REACT_APP_NAME}</title>
        <meta
          name="keywords"
          content="online law courses, online law courses in india, law courses in india, management course, law course, civil services, finance course, cyber security course, earn free certificate, online job oriented courses, best online law courses, best online law courses in india"
        />
        <meta
          name="description"
          content="Take online management and law courses from top institution. Learn about business law to advance your education and career with IALM Academy Today!"
        />
      </Helmet>
      <BreadCrumb title="Contact Us" desc="" />
      <section class=" py-5 d-flex align-items-center">
        <div class="container">
          <div class="row">
            <div class="col-md-6 bg-lightgrey rounded-2 p-0">
              <div className="">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.2869883074945!2d77.23441907604385!3d28.561143687317855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce24b9a146cf1%3A0x9c4142d8a9dcab9d!2sIndian%20Academy%20Of%20Law%20%26%20Management!5e0!3m2!1sen!2sin!4v1758096919130!5m2!1sen!2sin"
                  width="100%"
                  height="450"
                  style={{ border: "0" }}
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
            <div class="col-md-6 d-flex align-items-center justify-content-center px-lg-5">
              <div className="row">
                <div className="col-12 mb-2">
                  <HorizontalIconBox
                    iconSrc={`/icons/location.svg`}
                    title={"Address"}
                    desc={`81, National Park, Lajpat Nagar-IV, New Delhi, Delhi 110024, India`}
                    link=""
                  />
                </div>
                <div className="col-12 mb-2">
                  <HorizontalIconBox
                    iconSrc={`/icons/email.svg`}
                    title={"Email"}
                    desc={`registrar@ialm.academy`}
                    link=""
                  />
                </div>
                <div className="col-12">
                  <HorizontalIconBox
                    iconSrc={`/icons/call.svg`}
                    title={"Contact"}
                    desc={`+91 96507 27918, 1800 2586 884`}
                    link=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />
      <section class="py-5 d-flex align-items-center">
        <div class="container">
          <div class="row">
            <div class="col-md-6 d-flex align-items-center px-lg-5">
              <h2 class="h1 fw-500">Refund Policy</h2>
            </div>
            <div class="col-md-6 d-flex align-items-center justify-content-center px-lg-5">
              <p class="lead fw-500">
                If you have questions about our refund policy. Please check{" "}
                <a href="/page/refund-policy" target="_blank">
                  this
                </a>{" "}
                link or you may directly contact to us on learner suppport.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
